const Base62 = require( './Base62' )
const UuidBase62 = require( './UuidBase62' )

module.exports = { 
  Base62,
  UuidBase62,

  v4( ) { return UuidBase62.v4() },
  v1( ) { return UuidBase62.v1() },

  encode( str, prefix ) { return Base62.encode( str, prefix ) },
  decode( str, prefix ) { return Base62.decode( str, prefix ) }

}
